import { Input } from "@ad/anq-ui";
import { InputProps } from "@ad/anq-ui/lib/input";
import React from "react";

interface Props extends Omit<InputProps, "value" | "onChange"> {
  value?: number;
  onChange?: (v: number) => void;
}

/** 移除输入中的无效字符; 只允许1个小数点; 移除小数点后第3位开始的字符 */
export const formatInputString = (v: string) => {
  return v.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
};

const InputPercent = ({ value, onChange, ...inputProps }: Props) => {
  const handleChange = (v: string) => {
    onChange(Number(formatInputString(v)));
  };

  return (
    <Input
      suffix="%"
      {...inputProps}
      value={value}
      onChange={(e) => handleChange(e.target.value)}
    />
  );
};

export default InputPercent;
